module.exports = __webpack_public_path__ + "static/media/ic_nav_faq.6622f487.svg";